let module = angular.module('app.resources');

module.factory('Recording', ($resource) => {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/recordings/:id`,
    { id: '@id' },
    {
      update: {
        method: 'PUT',
      },
      segments: {
        method: 'GET',
        url: `${API_ROOT}/account/recordings/:id/segments`,
        isArray: true,
      },
      prepareDownload: {
        method: 'POST',
        url: `${API_ROOT}/account/recordings/:id/download`,
      },
      getKalturaExportStatus: {
        method: 'GET',
        url: `${API_ROOT}/account/recordings/:id/kaltura_export`,
      },
      startKalturaExport: {
        method: 'POST',
        url: `${API_ROOT}/account/recordings/:id/kaltura_export`,
      },
      getYoutubeExportStatus: {
        method: 'GET',
        url: `${API_ROOT}/account/recordings/:id/youtube_export`,
      },
      startYoutubeExport: {
        method: 'POST',
        url: `${API_ROOT}/account/recordings/:id/youtube_export`,
      },
      getVimeoExportStatus: {
        method: 'GET',
        url: `${API_ROOT}/account/recordings/:id/vimeo_export`,
      },
      startVimeoExport: {
        method: 'POST',
        url: `${API_ROOT}/account/recordings/:id/vimeo_export`,
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/recording.js